module.exports = __webpack_public_path__ + "images/help/video-preview-permission-e88abff5b9ab18cd2930225dcfccd988.jpg";